import { hooks } from "@/store.js";
import {
	getIsDifferentTerminal,
	getTwoAirplaneTimeBetween,
} from "@/utils/airplane.js";
import { Suspense, memo, useMemo } from "react";
import isEqual from "react-fast-compare";

interface IProps {
	lastNo: string;
	no: string;
	date: string;
	id: string;
}

const Inner = memo(({ lastNo, no, date }: IProps) => {
	const airplane = hooks.useOneAirplane({
		index: { where: "no", equals: no },
	});
	const lastAirplane = hooks.useOneAirplane({
		index: { where: "no", equals: lastNo },
	});
	// const lastAirplane = hooks.useOneAirplane({
	//   index: { where: 'no', equals: lastNo },
	// });
	hooks.useWatch(airplane);
	// hooks.useWatch(lastAirplane);

	const { hours, minutes } = useMemo(() => {
		return (
			getTwoAirplaneTimeBetween({
				no: lastNo,
				no2: no,
				date,
			}) || ({} as { hours?: number; minutes?: number })
		);
	}, [lastNo, no, date]);

	const bagDirect = airplane?.get("bagDirect");

	const isDifferentTerminal = getIsDifferentTerminal({ no, lastNo });
	const isDifferentCheckedBagKg =
		airplane?.get("checkedBagKg") !== lastAirplane?.get("checkedBagKg");

	return (
		<article className=" px-5 flex items-start ">
			<div className="w-12 h-12 flex  justify-center items-center">
				<i className="ic-round text-gray-400/60 text-xl md-transfer_within_a_station leading-none!" />
			</div>
			<div className="ml-[18px] flex-grow">
				<b className="text-sm flex items-center text-gray-400/70 font-[700] min-h-12 ">
					<span
						className={`min-w-12 ${
							!hours || hours < 2 ? "text-orange-500/80" : ""
						}`}
					>
						{hours ? `${hours}h` : ""}
						{minutes ? `${minutes}m` : ""}
					</span>
					<span className="mx-2 font-normal opacity-30">|</span>{" "}
					{bagDirect ? (
						"行李直达"
					) : (
						<span className="text-orange-500/80">行李重托</span>
					)}
					{isDifferentTerminal ? (
						<>
							<span className="mx-2 font-normal opacity-30">|</span>
							<span className="text-orange-500/80">不同航站楼</span>
						</>
					) : (
						" "
					)}
					{isDifferentCheckedBagKg ? (
						<>
							<span className="mx-2 font-normal opacity-30">|</span>
							<span className="text-orange-500/80">不同行李重量</span>
						</>
					) : (
						" "
					)}
				</b>
				{/* <span className='text-gray-500/70 font-[din] text-sm font-[600]'>
          12.12 23:05
        </span> */}
			</div>
			{/* <Checkbox
    // @ts-ignore type
    radius='full'
    className='pt-5'
  /> */}
		</article>
	);
}, isEqual);
const Skeleton = memo(() => {
	return <div className="h-12" />;
}, isEqual);
const Transfer = memo((props: IProps) => {
	return (
		<Suspense fallback={<Skeleton />}>
			<Inner {...props} />
		</Suspense>
	);
}, isEqual);

export default Transfer;
